import React from "react";
import KeyboardAltIcon from "@mui/icons-material/KeyboardAlt";

const Logo = ({ isFocusedMode, isMusicMode }) => {
  return (
    <div className="header" style={{visibility: isFocusedMode ? 'hidden' : 'visible' }}>
      <h1>
        Typer Dash <KeyboardAltIcon fontSize="large" />
      </h1>
      <span className="sub-header">
      Powered by DataVoid Community<br/>
        Enjoy an elegant typing experience!
      </span>
    </div>
  );
};

export default Logo;
